import { createFileRoute, redirect } from '@tanstack/react-router';
import { DEFAULT_PROFILE_TAB } from '@/components/profiles/profiles-page';

/** `/profiles` names no library, so it opens the first one. */
export const Route = createFileRoute('/profiles/')({
  beforeLoad: () => {
    throw redirect({ to: '/profiles/$tab', params: { tab: DEFAULT_PROFILE_TAB } });
  },
});
